<div class="banner-carousel-section" [hidden]="!banners().length">
    <owl-carousel-o [options]="customOptions" #owlCar (translated)="translated($event)" (dragging)="isDragging = $event.dragging">
        @for (_banner of banners(); track $index) {
        <ng-template [id]="_banner.id" carouselSlide>
            <!-- Do no remove this div , will mess up the carousel -->
            <!-- https://github.com/vitalii-andriiovskyi/ngx-owl-carousel-o/issues/67 -->
            <div>
                @switch (_banner?.click_action?.action) { @case (ClickActionChoices.link_category) {
                <!-- link category -->
                <a [owlRouterLink]="['/category/' + _banner.click_action.url_path]" [stopLink]="isDragging" [queryParams]="{ utm_source: 'home', utm_medium: 'banner' }">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.link_product) {
                <!-- link product -->
                <a [owlRouterLink]="['/products/' + _banner.click_action.url_path]" [queryParams]="{ utm_source: 'home', utm_medium: 'banner' }" [stopLink]="isDragging">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.search_keywords) {
                <!-- search keywords -->
                <a [owlRouterLink]="['/search']" [queryParams]="{
            q: _banner.click_action.value,
            utm_source: 'home',
            utm_medium: 'banner'
          }" [stopLink]="isDragging">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.product_flag) {
                <!-- product flags -->
                <a [owlRouterLink]="['/search']" [queryParams]="{
            tags: _banner.click_action.value,
            utm_source: 'home',
            utm_medium: 'banner'
          }" [stopLink]="isDragging">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.link_url) {
                <!-- link url -->
                <a [href]="_banner.click_action.value" target="_blank">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.link_collection) {
                <!-- link product collections -->
                <a [owlRouterLink]="['/search']" [queryParams]="{
            collection_ids: _banner.click_action.value,
            utm_source: 'home',
            utm_medium: 'banner'
          }">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.link_brand) {
                <!-- link brand -->
                <a [owlRouterLink]="['/search']" [queryParams]="{
            brand_id: _banner?.click_action?.value,
            brand_name: _banner?.title,
            utm_source: 'home',
            utm_medium: 'banner'
          }" [stopLink]="isDragging">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } @case (ClickActionChoices.none) {
                <!-- link brand -->
                <base-banner [banner]="_banner"></base-banner>
                } @default {
                <!-- default to products page -->
                <a [owlRouterLink]="['/products']" [queryParams]="{
            collection_ids: _banner.click_action.value,
            utm_source: 'home',
            utm_medium: 'banner'
          }" [stopLink]="isDragging">
                    <base-banner [banner]="_banner"></base-banner>
                </a>
                } }
            </div>
        </ng-template>
        }
    </owl-carousel-o>

    <!-- Buttons only visible when banners length greater than one -->
    @if (banners() && banners().length > 1) {
    <button class="prev-btn left-navigation" type="button" (click)="owlCar.prev()">Prev</button>
    <button class="next-btn right-navigation" type="button" (click)="owlCar.next()">Next</button>
    }
</div>